/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CotisationsEtrangersDto } from '../models/cotisations-etrangers-dto';
import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { LoadResult } from '../models/load-result';


/**
 * Fonctions de gestion des cotisations des Etrangers hors zone IC
 */
@Injectable({
  providedIn: 'root',
})
export class CotisationsEtrangersService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation cotisationsEtrangersGetList
   */
  static readonly CotisationsEtrangersGetListPath = '/api/cotisations-etrangers/list/{etrangerId}';

  /**
   * Renvoie la liste des cotisations de l'étranger spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cotisationsEtrangersGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  cotisationsEtrangersGetList$Response(params: {

    /**
     * Identifiant de l&#x27;étranger
     */
    etrangerId: number;
  }): Observable<StrictHttpResponse<Array<CotisationsEtrangersDto>>> {

    const rb = new RequestBuilder(this.rootUrl, CotisationsEtrangersService.CotisationsEtrangersGetListPath, 'get');
    if (params) {
      rb.path('etrangerId', params.etrangerId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<CotisationsEtrangersDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des cotisations de l'étranger spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `cotisationsEtrangersGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  cotisationsEtrangersGetList(params: {

    /**
     * Identifiant de l&#x27;étranger
     */
    etrangerId: number;
  }): Observable<Array<CotisationsEtrangersDto>> {

    return this.cotisationsEtrangersGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<CotisationsEtrangersDto>>) => r.body as Array<CotisationsEtrangersDto>)
    );
  }

  /**
   * Path part for operation cotisationsEtrangersLoadList
   */
  static readonly CotisationsEtrangersLoadListPath = '/api/cotisations-etrangers/load-list/{etrangerId}';

  /**
   * Renvoie la liste des cotisations de l'étranger spécifié (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cotisationsEtrangersLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  cotisationsEtrangersLoadList$Response(params: {

    /**
     * Identifiant de l&#x27;étranger
     */
    etrangerId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, CotisationsEtrangersService.CotisationsEtrangersLoadListPath, 'post');
    if (params) {
      rb.path('etrangerId', params.etrangerId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des cotisations de l'étranger spécifié (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `cotisationsEtrangersLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  cotisationsEtrangersLoadList(params: {

    /**
     * Identifiant de l&#x27;étranger
     */
    etrangerId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.cotisationsEtrangersLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation cotisationsEtrangersGet
   */
  static readonly CotisationsEtrangersGetPath = '/api/cotisations-etrangers/{id}';

  /**
   * Renvoie la cotisation d'un étranger spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cotisationsEtrangersGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  cotisationsEtrangersGet$Response(params: {

    /**
     * Identifiant de la cotisation d&#x27;un étranger spécifiée
     */
    id: number;
  }): Observable<StrictHttpResponse<CotisationsEtrangersDto>> {

    const rb = new RequestBuilder(this.rootUrl, CotisationsEtrangersService.CotisationsEtrangersGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CotisationsEtrangersDto>;
      })
    );
  }

  /**
   * Renvoie la cotisation d'un étranger spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `cotisationsEtrangersGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  cotisationsEtrangersGet(params: {

    /**
     * Identifiant de la cotisation d&#x27;un étranger spécifiée
     */
    id: number;
  }): Observable<CotisationsEtrangersDto> {

    return this.cotisationsEtrangersGet$Response(params).pipe(
      map((r: StrictHttpResponse<CotisationsEtrangersDto>) => r.body as CotisationsEtrangersDto)
    );
  }

  /**
   * Path part for operation cotisationsEtrangersPut
   */
  static readonly CotisationsEtrangersPutPath = '/api/cotisations-etrangers/{id}';

  /**
   * Met à jour la cotisation d'un étranger spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cotisationsEtrangersPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  cotisationsEtrangersPut$Response(params: {

    /**
     * Identifiant de la cotisation d&#x27;un étranger à mettre à jour
     */
    id: number;

    /**
     * Cotisation d'un étranger
     */
    body: CotisationsEtrangersDto
  }): Observable<StrictHttpResponse<CotisationsEtrangersDto>> {

    const rb = new RequestBuilder(this.rootUrl, CotisationsEtrangersService.CotisationsEtrangersPutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CotisationsEtrangersDto>;
      })
    );
  }

  /**
   * Met à jour la cotisation d'un étranger spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `cotisationsEtrangersPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  cotisationsEtrangersPut(params: {

    /**
     * Identifiant de la cotisation d&#x27;un étranger à mettre à jour
     */
    id: number;

    /**
     * Cotisation d'un étranger
     */
    body: CotisationsEtrangersDto
  }): Observable<CotisationsEtrangersDto> {

    return this.cotisationsEtrangersPut$Response(params).pipe(
      map((r: StrictHttpResponse<CotisationsEtrangersDto>) => r.body as CotisationsEtrangersDto)
    );
  }

  /**
   * Path part for operation cotisationsEtrangersPost
   */
  static readonly CotisationsEtrangersPostPath = '/api/cotisations-etrangers/{etrangerId}';

  /**
   * Crée la cotisation d'un étranger spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cotisationsEtrangersPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  cotisationsEtrangersPost$Response(params: {

    /**
     * Identifiant de l&#x27;étranger
     */
    etrangerId: number;

    /**
     * Cotisation d'un étranger
     */
    body: CotisationsEtrangersDto
  }): Observable<StrictHttpResponse<CotisationsEtrangersDto>> {

    const rb = new RequestBuilder(this.rootUrl, CotisationsEtrangersService.CotisationsEtrangersPostPath, 'post');
    if (params) {
      rb.path('etrangerId', params.etrangerId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CotisationsEtrangersDto>;
      })
    );
  }

  /**
   * Crée la cotisation d'un étranger spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `cotisationsEtrangersPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  cotisationsEtrangersPost(params: {

    /**
     * Identifiant de l&#x27;étranger
     */
    etrangerId: number;

    /**
     * Cotisation d'un étranger
     */
    body: CotisationsEtrangersDto
  }): Observable<CotisationsEtrangersDto> {

    return this.cotisationsEtrangersPost$Response(params).pipe(
      map((r: StrictHttpResponse<CotisationsEtrangersDto>) => r.body as CotisationsEtrangersDto)
    );
  }

}
